import gsap from 'gsap'
import CustomEase from 'gsap/dist/CustomEase'
import Flip from 'gsap/dist/Flip'
import InertiaPlugin from 'gsap/dist/InertiaPlugin'
import Physics2DPlugin from 'gsap/dist/Physics2DPlugin'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import SplitText from 'gsap/dist/SplitText'

if (typeof window !== 'undefined') {
  gsap.registerPlugin(CustomEase, Flip, InertiaPlugin, Physics2DPlugin, ScrollTrigger, SplitText)
  CustomEase.create('inOut4', 'M0,0 C0.4,0 -0.06,1 1,1', { precision: 2 })
}
